import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/format";

export const mediaUrl = (m) => (m && m.type !== "youtube" ? `${API}/campaign-media/${m.id}` : null);

export const ytId = (url) => {
  const s = (url || "").trim();
  const m = /(?:youtu\.be\/|[?&]v=|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/.exec(s);
  return m ? m[1] : /^[A-Za-z0-9_-]{11}$/.test(s) ? s : null;
};

const YouTube = ({ id, className }) => {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const h = (e) => {
      if (e.source !== ref.current?.contentWindow) return;
      try {
        const d = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if ((d.event === "onStateChange" && d.info === 1) || d.info?.playerState === 1) setOn(true);
      } catch { /* non-player message */ }
    };
    window.addEventListener("message", h);
    return () => window.removeEventListener("message", h);
  }, []);
  const listen = () => ref.current?.contentWindow?.postMessage(JSON.stringify({ event: "listening", id: 1, channel: "widget" }), "*");
  const q = `autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&modestbranding=1&rel=0&iv_load_policy=3&disablekb=1&fs=0&cc_load_policy=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;
  return (
    <div className={`relative overflow-hidden bg-black [container-type:size] ${className}`} data-testid="campaign-media-youtube" data-playing={on ? "1" : "0"}>
      <iframe ref={ref} title="Campaign video" src={`https://www.youtube-nocookie.com/embed/${id}?${q}`} allow="autoplay; encrypted-media" tabIndex={-1} onLoad={listen}
        className={`pointer-events-none absolute left-1/2 top-1/2 h-[max(132%,74.3cqw)] w-[max(132%,235cqh)] -translate-x-1/2 -translate-y-1/2 border-0 transition-opacity duration-700 ${on ? "opacity-100" : "opacity-0"}`} />
    </div>
  );
};

export const CampaignMedia = ({ media, className = "" }) => {
  if (!media) return null;
  if (media.type === "youtube") return <YouTube id={media.id} className={className} />;
  if (media.type === "video") {
    return <video src={mediaUrl(media)} muted autoPlay loop playsInline preload="auto" className={`object-cover ${className}`} data-testid="campaign-media-video" />;
  }
  return <img src={mediaUrl(media)} alt="" draggable={false} className={`object-cover ${className}`} data-testid="campaign-media-image" />;
};

export const CampaignSlideView = ({ media, kicker, title, body, children, className = "", textClass = "" }) => (
  <div className={`relative overflow-hidden bg-[#1D1D1F] ${className}`} data-testid="campaign-slide">
    <CampaignMedia media={media} className="absolute inset-0 h-full w-full" />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent" />
    <div className={`absolute bottom-0 left-0 max-w-[720px] p-8 text-left text-white lg:p-12 pk:!max-w-none pk:!p-12 ${textClass}`}>
      <p className="text-[15px] font-semibold text-[#5EEAD4]">{kicker}</p>
      <p className="font-display mt-1 text-5xl font-extrabold leading-[1] tracking-[-0.04em] lg:text-6xl pk:!text-[8vw]" data-testid="campaign-slide-title">{title}</p>
      {body && <p className="mt-3 text-lg text-white/80" data-testid="campaign-slide-body">{body}</p>}
      {children}
    </div>
  </div>
);
